<template>
	<div class="card bd-0">
		<div class="table-responsive">
			<table class="table table-dashboard mg-b-0" aria-describedby="transactions-table">
				<thead>
					<tr>
						<th scope="col">Transaction ID</th>
						<th scope="col">Date</th>
						<th scope="col">Security</th>
						<th scope="col">Action</th>
						<th scope="col" class="text-right" v-if="showUnits">Units</th>
						<th scope="col" class="text-right" v-if="showPrice">Price</th>
						<th scope="col" class="text-right">Value</th>
						<th scope="col" class="text-center">Status</th>
					</tr>
				</thead>
				<tbody>
					<tr v-if="loading">
						<td colspan="7"><spinner-component :loading="loading" /></td>
					</tr>
					<tr v-if="error" class="tx-center tx-danger">
						<td colspan="7">{{ error }}</td>
					</tr>

					<tr v-else v-for="(transaction, index) in transactions" :key="index">
						<td class="tx-color-03 tx-normal">{{ transaction.uuid }}</td>
						<td class="tx-color-03 tx-normal">{{ transaction.date | toDate('Do MMMM YYYY') }}</td>
						<td class="tx-color-03 tx-medium" v-tooltip:top="transaction.asset.description">{{ transaction.asset.name }}</td>
						<td class="tx-color-03 tx-normal">{{ transaction.type }}</td>
						<td class="tx-medium text-right" v-if="showUnits">{{ transaction.currency }} {{ getUnits(transaction) | toNumber('0,0.0000') }}</td>
						<td class="tx-medium text-right" v-if="showPrice">{{ transaction.price | toNumber('0,0.0000') }}</td>
						<td class="tx-medium text-right">
							{{ calculateTransactionValue(transaction) | toNumber('0,0.0000') }}
						</td>
						<td class="tx-medium text-center" v-html="transactionStatus(transaction.status)"></td>
					</tr>
					<tr>
						<td v-if="!loading && !transactions" class="tx-medium text-center" :class="[loading ? 'bd-t-0' : '']" colspan="7">No Data Available</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import { requests } from '../../../../mixins';

export default {
	mixins: [requests.transactions],
	data() {
		return {
			loading: false,
			transactions: null,
			error: null,
		};
	},
	created() {
		this.fetchTransactions();
	},
	methods: {
		fetchTransactions() {
			this.error = this.transactions = null;
			this.loading = true;

			axios
				.get(`/api/portfolio/${this.$route.params.portfolio}/transactions`)
				.then((response) => {
					const transactions = response.data.data.transactions;

					if (!_.isEmpty(transactions)) {
						this.transactions = transactions;
					}
				})
				.catch((error) => {
					this.error = error.toString();
				})
				.finally(() => {
					this.loading = false;
				});
		},
		getUnits(transaction) {
			const { type, units, charges } = transaction;

			if (['investment', 'deposit'].includes(_.lowerCase(type))) {
				return units - charges;
			}

			return units;
		},
		calculateTransactionValue(transaction) {
			const { type, units, charges, price } = transaction;

			if (['ipo', 'deposit'].includes(_.lowerCase(type))) {
				return ((units - charges) * price).toFixed(2);
			}

			if (['investment'].includes(_.lowerCase(type))) {
				return (units - charges).toFixed(2);
			}

			if (['withdraw'].includes(_.lowerCase(type))) {
				return (units * 1).toFixed(2);
			}

			return (units * price).toFixed(2);
		},
	},
	props: {
		portfolioId: {
			type: String,
		},
		type: {
			type: String,
		},
		showPrice: {
			type: Boolean,
			default: true,
		},
		showUnits: {
			type: Boolean,
			default: true,
		},
	},
};
</script>
